import type { ScopedStyleSheet } from "@nectary/scoped-stylesheet";
import themeBase from "@nectary/theme-base";

export const getThemeClassNames = (
  portalExtraNectaryTheme: string | null,
  vendor?: string | null
) => {
  if (vendor === "simpletexting") {
    return "nectary-theme-base nectary-theme-simple-texting";
  }

  /*Needs to load mm themes in case override stylesheet from mfe-login does not load */
  if (vendor === "vodanz") {
    return "nectary-theme-base nectary-theme-message-media nectary-theme-vodanz";
  }

  if (vendor === "2degrees") {
    return "nectary-theme-base nectary-theme-message-media nectary-theme-2degrees";
  }

  if (vendor === "tpgtelecom") {
    return "nectary-theme-base nectary-theme-message-media nectary-theme-tpgtelecom";
  }

  if (vendor === "etxt") {
    return "nectary-theme-base nectary-theme-message-media nectary-theme-etxt";
  }

  if (portalExtraNectaryTheme === "message-media") {
    return "nectary-theme-base nectary-theme-message-media";
  }

  return `nectary-theme-base ${portalExtraNectaryTheme}`;
};

/** Needs to be called after the shadow root was created */
export const loadThemes = async (
  scopedStyleSheet: ScopedStyleSheet,
  classNames: string
) => {
  scopedStyleSheet.addStyle(themeBase);
  if (classNames.includes("message-media")) {
    const mediaMessageTheme = await import("@nectary/theme-message-media");
    scopedStyleSheet.addStyle(mediaMessageTheme.default);
  }
  if (classNames.includes("simple-texting")) {
    const simpleTextingTheme = await import("@nectary/theme-simple-texting");
    scopedStyleSheet.addStyle(simpleTextingTheme.default);
  }
  if (classNames.includes("cpaas-theme-base")) {
    const cpaasBaseTheme = await import("@nectary/theme-cpaas-base");
    scopedStyleSheet.addStyle(cpaasBaseTheme.default);
  }
  if (classNames.includes("cpaas-theme-dashboard")) {
    const cpaasDashboardTheme = await import("@nectary/theme-cpaas-dashboard");
    scopedStyleSheet.addStyle(cpaasDashboardTheme.default);
  }
};
